// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__6WNxx","image":"Header_image__gIpdW","name":"Header_name__MHbUA","info":"Header_info__1Lkyb","infoRow":"Header_infoRow__12lUv"};